<template>
  <div class="services-test-area bg-mg ptb-100 position-relative overflow-hidden"
    :style="{ backgroundImage: 'url(' + (c.background_image_url || bgImage) + ')' }">
    <div class="container mw-1356">
      <div class="services-test-content" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
        <span class="top-title">{{ c.top_title }}</span>
        <h2 class="text-white">{{ c.title }}</h2>
        <p class="text-silver">{{ c.subtitle }}</p>
        <div class="d-flex align-items-center amount">
          <div class="flex-shrink-0"><i class="flaticon-tv"></i></div>
          <div class="flex-grow-1 ms-3">
            <h2>${{ c.price }}<sub>/ {{ c.period }}</sub></h2>
            <span>{{ c.period_label }}</span>
          </div>
        </div>
        <div v-if="trialSent" class="trial-success">
          <i class="ti ti-circle-check"></i>
          <span>{{ trialMessage }}</span>
        </div>
        <form v-else class="trial-form" @submit.prevent="submitTrial">
          <input
            v-model="trialName"
            type="text"
            class="form-control"
            placeholder="Your name"
            :disabled="trialLoading"
          />
          <input
            v-model="trialEmail"
            type="email"
            class="form-control"
            placeholder="Your email"
            required
            :disabled="trialLoading"
          />
          <button type="submit" class="btn bg-grey-teal" :disabled="trialLoading">
            <span class="border-style">{{ trialLoading ? 'Sending...' : (c.cta_text || 'Start Free Trial') }}</span>
          </button>
        </form>
        <p v-if="trialError" class="trial-error">{{ trialError }}</p>
        <div class="d-flex gap-2 flex-wrap mt-3">
          <a :href="'tel:' + c.phone" class="btn bg-transparent">
            <span class="border-style"><span>Call: {{ c.phone }}</span> for any enquiry</span>
          </a>
        </div>
      </div>
    </div>
    <img src="@/assets/images/shape-9.png" class="shape shape-9" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useContent } from "@/composables/useContent";
import { useRecaptcha } from "@/composables/useRecaptcha";
import api from "@/services/api";

export default defineComponent({
  name: "TestOurService",
  setup() {
    const { content: c } = useContent("test_service", {
      top_title: "TESTING", title: "Start now. Don't hesitate to test our service",
      subtitle: "Test account. Get full access to all channels and VOD",
      price: "14.99", period: "month", period_label: "1 Month Test Satisfied Or Refunded.",
      cta_text: "Start Free Trial", phone: "+321 234 4567",
      background_image_url: "",
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/services-test-bg.jpg");

    const { getToken } = useRecaptcha();
    const trialName = ref("");
    const trialEmail = ref("");
    const trialLoading = ref(false);
    const trialSent = ref(false);
    const trialMessage = ref("");
    const trialError = ref("");

    async function submitTrial() {
      if (!trialEmail.value.trim()) return;
      trialError.value = "";
      trialLoading.value = true;
      try {
        const recaptcha_token = await getToken("trial");
        const { data } = await api.post("/api/v1/trial", {
          name: trialName.value,
          email: trialEmail.value,
          recaptcha_token,
        });
        trialMessage.value = data.message || "Thanks! Check your email shortly.";
        trialSent.value = true;
      } catch (e: any) {
        trialError.value = e?.response?.data?.message || "Something went wrong. Please try again.";
      } finally {
        trialLoading.value = false;
      }
    }

    return {
      c, bgImage,
      trialName, trialEmail, trialLoading, trialSent, trialMessage, trialError, submitTrial,
    };
  },
});
</script>

<style scoped>
.trial-form {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  max-width: 560px;
  margin-top: 0.5rem;
}
.trial-form .form-control {
  flex: 1 1 180px;
  border-radius: 50px;
  border: 1px solid #5e5556;
  background: rgba(54, 43, 44, 0.25);
  backdrop-filter: blur(10px);
  height: 54px;
  padding: 0 22px;
  color: #fff;
}
.trial-form .form-control::placeholder { color: #cfcaca; }
.trial-form .btn { flex: 0 0 auto; }
.trial-success {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(74, 222, 128, 0.15);
  border: 1px solid #4ade80;
  color: #b7f5cd;
  border-radius: 10px;
  padding: 0.9rem 1.25rem;
  font-size: 0.95rem;
  max-width: 560px;
}
.trial-success i { font-size: 1.2rem; color: #4ade80; }
.trial-error { color: #ff9a9a; font-size: 0.85rem; margin-top: 0.5rem; }
</style>
